export default __webpack_public_path__ + "static/media/sunseeker-300w-min.f962ead6.jpeg";